import { createSelector } from 'reselect';
import * as types from '../actions/actionTypes';
import { color2string } from '../helper/ColorUtils';
import { isNumeric } from './../helper/utils';
import {
    getCurrentPatternColors,
    getCurrentPatternId,
    getCurrentPatternTitle,
} from './currentPattern';
import { getCurrentPatternDesignerName } from './designer';
import {
    getActiveFabricId,
    getActiveFabricMaterial,
    getActiveFabricProcessingTime,
    getActiveFabricTitle,
} from './fabrics';
import { defaultQty } from './initialState';
import { getSchnoffNetPrice, isShippingFree } from './prices';
import { getActiveProductData, getActiveProductId } from './products';
import {
    getActiveSewpat,
    getFabricDisplayLengthBySize,
    getFabricLengthBySize,
    getFashionSize,
    getSelectedSewpatOptions,
} from './sewpats';

export default (state, action) => {
    let newState;
    let value = action.value;
    let error;
    let errorMessage;
    let help;
    let helpMessage;

    switch (action.type) {
        case types.QTY_CHANGED:

            // Check if we have a valid value here (decimal seperator issue)
            if (action.inputType === 'number' && action.error) {
                error = true;
            }

            if (action.inputType === 'text') {
                // Replace any comma with dot values.
                value = action.value.trim().replace(/,/g, '.');
            }

            value = parseInt(value, 10);

            if (isNumeric(value)) {
                if (value < 1) {
                    error = true;
                }
            }
            else {
                error = true;
            }

            if (error) {
                newState = Object.assign({}, state, {
                    error: true,
                });
            }
            else {
                newState = Object.assign({}, state, {
                    qty: value,
                    error: false,
                });
            }
            return newState;

        case types.CART_RESETTED:
            newState = Object.assign({}, state, {
                qty: defaultQty,
                error,
            });
            return newState;

        default:
            return state;
    }
};

export const getSewpatQty = state => parseFloat(state.stolo.cart.qty);
export const hasError = state => state.stolo.cart.error;
export const hasHelp = state => state.stolo.cart.help;
export const getErrorMessage = state => state.stolo.cart.errorMessage;
export const getHelpMessage = state => state.stolo.cart.helpMessage;

const getProductCategory = createSelector(
    [isShippingFree],
    isShippingFree => isShippingFree ? 'shipping_free' : 'DEFAULT',
);

export const getProductFormData = createSelector(
    [
        getSewpatQty,
        hasError,
        hasHelp,
        getErrorMessage,
        getHelpMessage,
        getSchnoffNetPrice,
        getActiveSewpat,
        getFashionSize,
        getActiveFabricTitle,
        getActiveFabricId,
        getCurrentPatternId,
        getCurrentPatternColors,
        getCurrentPatternTitle,
        getCurrentPatternDesignerName,
        getActiveFabricProcessingTime,
        getActiveFabricMaterial,
        getSelectedSewpatOptions,
        getActiveProductId,
        getActiveProductData,
        getProductCategory,
    ],
    (
        quantity,
        error,
        help,
        errorMessage,
        helpMessage,
        price,
        sewpat,
        size,
        fabricname,
        fabricId,
        designId,
        colors,
        patterntitle,
        designer,
        processingtime,
        fabricmaterial,
        options,
        productVariation,
        productVariationProductData,
        category,
    ) => {
        const fabriclength = `${getFabricDisplayLengthBySize(
            sewpat,
            size,
            options,
        )}cm`;
        const printlength = getFabricLengthBySize(sewpat, size, options);
        var formData = {};
        if (productVariation === 'schnoff') {
            formData = Object.assign(
                {},
                {
                    quantity,
                    price,
                    error,
                    errorMessage: error ? errorMessage : '',
                    help,
                    helpMessage: help ? helpMessage : '',
                    code: sewpat.id,
                    patterntitle,
                    size,
                    fabricname: `${fabricname}(${fabricmaterial})`,
                    fabricId,
                    fabricmaterial,
                    processingtime,
                    designId,
                    designer,
                    colors: color2string(colors),
                    name: `${sewpat.title}: ${patterntitle}`,
                    fabriclength,
                    printlength,
                    source: 'schnoffle',
                    category,
                },
            );
        }
        if (productVariation === 'fabric') {
            formData = Object.assign(
                {},
                {
                    quantity,
                    price,
                    error,
                    errorMessage: error ? errorMessage : '',
                    help,
                    helpMessage: help ? helpMessage : '',
                    code: sewpat.id,
                    patterntitle,
                    size,
                    fabricname: `${fabricname}(${fabricmaterial})`,
                    fabricId,
                    fabricmaterial,
                    processingtime,
                    designId,
                    designer,
                    colors: color2string(colors),
                    name: `${patterntitle}`,
                    fabriclength,
                    printlength,
                    source: 'schnoffle',
                    category,
                },
                productVariationProductData,
            );
        }
        if (productVariation === 'sewingpattern') {
            formData = Object.assign(
                {},
                {
                    quantity,
                    price,
                    error,
                    errorMessage: error ? errorMessage : '',
                    help,
                    helpMessage: help ? helpMessage : '',
                    code: sewpat.id,
                    name: `${sewpat.title}`,
                },
                productVariationProductData,
            );
        }
        return formData;
    },
);




// WEBPACK FOOTER //
// ./src/reducers/cart.js